import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import PhotoIcon from "@mui/icons-material/Photo";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import {
//   setDocumentoUnoFileName,
//   setDocumentoDosFileName,
//   setDocumentoTresFileName,
//   setDocumentoCuatroFileName,
// } from "../actions";
import { useSelector } from "react-redux";
// import ItemFileUploaderCard from "~business/Cards/ItemFileUploaderCard.tsx";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import GalleryWithLightbox from "~styled/gallery/GalleryWithLightBox";
import { SliceDetalleSiniestro } from "../../types";

const useStyles = makeStyles((theme) => {
  return {
    container: {
      padding: "2%",
      borderBottom: "1px solid #8B8B8B",
    },
    noDocumentsText: {
      fontFamily: "Nunito",
      fontSize: "16px",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.38,
      letterSpacing: "normal",
      textAlign: "center",
      color: "#8B8B8B",
    },
    pdfContainer: {
      display: "flex",
      flexDirection: "column",
      padding: "2%",
      gap: "8px",
    },
    pdfLink: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontFamily: "Nunito",
      fontSize: "16px",
      fontWeight: 600,
      color: "#f77221",
      textDecoration: "none",
    },
  };
});

const title = "Documentación";

// const partes = {
//   documentoUno: setDocumentoUnoFileName,
//   documentoDos: setDocumentoDosFileName,
//   documentoTres: setDocumentoTresFileName,
//   documentoCuatro: setDocumentoCuatroFileName,
// };

const useReduxSelector = () =>
  useSelector<any, SliceDetalleSiniestro>((state) => {
    const siniestro = state.detalleSiniestroReducer
      ? state.detalleSiniestroReducer.currentSiniestro
      : {};
    return {
      ...siniestro,
    };
  });

/**
 * `IconHeader` sólo se usa mientras carga, y el detalle no lo pasa: la tarjeta
 * en carga se muestra sin ícono.
 */
interface DocumentacionCardProps {
  isLoading: boolean;
  IconHeader?: React.ComponentType<{ className?: string }>;
}

const DocumentacionCard = ({
  isLoading,
  IconHeader,
}: DocumentacionCardProps) => {
  const { documentacion } = useReduxSelector();
  const classes = useStyles();

  if (isLoading)
    return (
      <DetalleCard
        isLoading={isLoading}
        title={title}
        IconHeader={IconHeader}
      />
    );

  let documentos: {
    src: string;
    thumbnail: string;
    width: number;
    height: number;
  }[] = [];
  let pdfs: string[] = [];

  const esPdf = (documento: string) =>
    documento.split("?")[0].toLowerCase().endsWith(".pdf");

  if (documentacion) {
    documentos = documentacion
      .filter((documento) => !esPdf(documento))
      .map((documento) => ({
        src: documento,
        thumbnail: documento,
        width: 80,
        height: 80,
      }));
    pdfs = documentacion.filter(esPdf);
  }

  const documentosLoaded = documentos.length > 0 || pdfs.length > 0;

  return (
    <DetalleCard isLoading={isLoading} title={title} IconHeader={PhotoIcon}>
      {documentos.length > 0 && <GalleryWithLightbox imagenes={documentos} />}
      {pdfs.length > 0 && (
        <div className={classes.pdfContainer}>
          {pdfs.map((pdf, i) => (
            <a
              key={pdf}
              href={pdf}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.pdfLink}
            >
              <PictureAsPdfIcon />
              {`Documento PDF ${i + 1}`}
            </a>
          ))}
        </div>
      )}
      {!documentosLoaded && (
        <div className={classes.container}>
          <Typography className={classes.noDocumentsText}>
            {"No se han cargado documentos."}
          </Typography>
        </div>
      )}
    </DetalleCard>
  );
};

export default DocumentacionCard;
